import { twMerge } from "tailwind-merge";

const ChevronTop = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge("fill-zinc-50", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5397 11.5812C18.9425 12.1554 17.9929 12.1368 17.4187 11.5397L10 3.66416L2.58125 11.5397C2.00706 12.1368 1.0575 12.1554 0.46034 11.5812C-0.136816 11.0071 -0.155436 10.0575 0.418754 9.46034L8.91875 0.460336C9.20156 0.166218 9.59197 -9.9745e-07 10 -1.03312e-06C10.408 -1.06879e-06 10.7984 0.166218 11.0812 0.460336L19.5812 9.46033C20.1554 10.0575 20.1368 11.0071 19.5397 11.5812Z"
      />
    </svg>
  );
};

export default ChevronTop;
